module.exports = __webpack_public_path__ + "static/media/ana_branca.3333cfcd.PNG";